var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPartnerWithUsHeaderBgD = function SvgPartnerWithUsHeaderBgD(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 524,
    height: 485,
    viewBox: "0 0 524 485",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "86.841%",
    x2: "13.918%",
    y1: "55.073%",
    y2: "28.285%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#9A5AD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#48A2ED"
  })), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M76.307 301.174c61.705 290.321 234.308 88.787 306.32 278.918 59.432 156.911 283.855 121.206 348.387-45.4 33.416-86.272 30.97-271.79-159.643-375.475C389.544 60.31 14.602 10.852 76.307 301.174z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "97.848%",
    x2: "15.776%",
    y1: "-8.471%",
    y2: "60.663%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#9A5AD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#48A2ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "64.727%",
    x2: "64.727%",
    y1: "67.925%",
    y2: "135.857%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#9A5AD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#48A2ED"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "rotate(-21 -204.247 906.072)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#b)",
    transform: "rotate(16 408.425 381.355)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 132.821,
    cy: 453.167,
    fill: "url(#c)",
    mask: "url(#d)",
    rx: 213,
    ry: 224
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPartnerWithUsHeaderBgD);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/partner-with-us-header-bg-d.0c7ff51ce83fd2b9aad25b0bf59eb081.svg";